import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import INFO from "../data/user";

const ComingSoon = () => {
	useEffect(() => {
		document.title = `Project Details | Azerty Labs`;
	}, []);

	return (
		<React.Fragment>
			<div className="min-h-screen bg-lab-bg flex flex-col items-center justify-center relative">
				{/* Background decoration */}
				<div className="absolute inset-0 bg-grid-pattern bg-[size:50px_50px] opacity-20" />
				
				<div className="relative z-10 text-center px-6">
					{/* Status badge */}
					<div className="inline-flex items-center gap-2 mb-8 px-4 py-2 rounded-full border border-lab-text-dim/30 bg-lab-bg-card/50 backdrop-blur-sm">
						<span className="w-2 h-2 rounded-full bg-lab-amber animate-pulse" />
						<span className="text-sm font-mono text-lab-text-muted tracking-wider">
							ARCHIVE MODE
						</span>
					</div>

					<h1 className="text-4xl lg:text-5xl font-mono font-bold text-lab-text mb-6">
						Project Archive
					</h1>
					
					<div className="text-lg text-lab-text-muted max-w-md mx-auto mb-8">
						<p className="mb-4">
							This project was part of the Azerty Labs journey.
						</p>
						<p>
							The lab is closed now, but you can explore the archive 
							or connect with me to learn more.
						</p>
					</div>

					{/* Social links */}
					<div className="flex justify-center gap-4 mb-12">
						{Object.entries(INFO.socials).map(([key, social]) => (
							social.icon && (
								<a
									key={key}
									href={social.link}
									target="_blank"
									rel="noopener noreferrer"
									className="p-3 rounded-lg bg-lab-bg-card border border-lab-text-dim/20 text-lab-text-muted hover:text-lab-cyan hover:border-lab-cyan/30 transition-all duration-300"
								>
									<FontAwesomeIcon icon={social.icon} className="text-xl" />
								</a>
							)
						))}
					</div>

					{/* Back button */}
					<a 
						href="/" 
						className="inline-flex items-center gap-2 px-6 py-3 bg-lab-cyan text-lab-bg font-mono font-semibold rounded-lg hover:bg-lab-text transition-all duration-300"
					>
						<svg 
							className="w-4 h-4" 
							fill="none" 
							viewBox="0 0 24 24" 
							stroke="currentColor"
						>
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
						</svg>
						<span>Back to Archive</span>
					</a>
				</div>
			</div>
		</React.Fragment>
	);
};

export default ComingSoon;
